require("./bootstrap");
require("./svg-inject.min.js");

import Vue from "vue";
import Vuetify from "vuetify";
import "regenerator-runtime/runtime.js";
import App from "./App.vue";
import { ValidationProvider } from "vee-validate";
import router from "@src/router";
import store from "@src/_store/store";
import _ from "lodash";
import "@src/filters/time-filter.js";
import "@src/filters/currency-filter.js";
import "@src/filters/decimal-currency-filter.js";
import "@src/filters/number-filter.js";
import ComponenteLoading from "@components/shared/widgets/LoadingComponent.vue";
import EventBusLoading from "@src/_event-bus/_loadings.js";
import { AuthServicesDomainValidation } from "@services/AuthServices";
import {registerServiceWorker} from "@plugins/pusherHub.js";
import dayjs from "dayjs";
import analytics from "@plugins/analytics.js";

// i18n
import i18n from "./plugins/i18n";
import pt from "vuetify/src/locale/pt.ts";
import en from "vuetify/src/locale/en.ts";
import it from "vuetify/src/locale/it.ts";
import es from "vuetify/src/locale/es.ts";
import fr from "vuetify/src/locale/fr.ts";

//configs
import "./vue-components";
import "./axios-config";

Vue.mixin({
    methods: {
        // To Type Number Only - Function to reserve numbers only and exlucide (e, +, etc)
        onlyNumberRule(event) {
            if (
                (event.which != 8 &&
                    event.which != 0 &&
                    event.which !== 44 &&
                    event.which !== 46 &&
                    event.which < 48) ||
                event.which > 57
            ) {
                event.preventDefault();
            }
        },
        onlyNumberAndSpecialRule(event) {
            if (
                (event.which != 8 &&
                    event.which != 0 &&
                    event.which !== 42 &&
                    event.which !== 44 &&
                    event.which !== 45 &&
                    event.which !== 46 &&
                    event.which < 48) ||
                event.which > 57
            ) {
                event.preventDefault();
            }
        },
        // Exclude '.' and ','
        onlyNumberRule2(event) {
            const tecla = event.keyCode || event.which;
            if (tecla < 48 || tecla > 57) {
                event.preventDefault();
            }
        },
    },
});

Vue.use(analytics, { store });

getSubDomain();

function getSubDomain() {
    let domainInfo;
    AuthServicesDomainValidation()
        .then((response) => {
            domainInfo = response.data.result;

            localStorage.setItem(
                "@datadrive:domain",
                JSON.stringify(domainInfo)
            );

            let favicon = document.querySelector("link[rel~='icon']");
            if (!favicon) {
                favicon = document.createElement("link");
                favicon.rel = "icon";
                favicon.href = domainInfo.faviconIcon;
                document.getElementsByTagName("head")[0].appendChild(favicon);
            }
            favicon.href = domainInfo.faviconIcon;
        })
        .catch((error) => {
            console.error("error get domain validation", error);
        })
        .finally(() => {
            let opts = {
                theme: {
                    options: {
                        customProperties: true,
                    },
                    themes: {
                        light: {
                            primary: domainInfo
                                ? `${domainInfo.primaryColorHex}`
                                : "#4caf50",
                            info: domainInfo
                                ? `${domainInfo.infoColorHex}`
                                : "#9E9D9D",
                            success: domainInfo
                                ? `${domainInfo.primaryColorHex}`
                                : "#4caf50", //mesmo do Primary
                            error: "#D90B3B",
                            bgLogin: domainInfo
                                ? `${domainInfo.loginBgColorHex}`
                                : "#4b4849",

                            accent: "#F59433", //Buttom Back
                            green: "#3da150",
                            red: "#D90B3B",
                            blue: "#06A7E0",
                            grey: "#9E9D9D",
                            yellow: "#fbe122",
                        },
                    },
                },

                lang: {
                    locales: { en, pt, it, es, fr },
                    current: "pt",
                },
            };

            const vuetify = new Vuetify(opts);

            return new Vue({
                render: (h) => h(App),
                store,
                router,
                vuetify,
                ValidationProvider,
                i18n,

                components: {
                    ComponenteLoading,
                },

                data: {
                    loadings: {
                        showLoadingTemplate: {
                            show: "",
                            size: "120px",
                            margin: "-60px 0 0 -60px", // Margin sempre é a metade do size
                        },
                        showLoadingHeader: {
                            show: "",
                            size: "50px",
                            margin: "-25px 0 0 -25px",
                        },
                        showLoadingSidebar: {
                            show: "",
                            size: "64px",
                            margin: "-32px 0 0 -32px",
                        },
                        showLoadingMain: {
                            show: "",
                            size: "90px",
                            margin: "-45px 0 0 -45px",
                        },
                        showLoadingFooter: {
                            show: "",
                            size: "30px",
                            margin: "-15px 0 0 -15px",
                        },
                    },
                },
                computed: {
                    showLoadingSidebar() {
                        this.loadings.showLoadingSidebar =
                            this.$store.getters[
                                "loadings/getLoadingState"
                            ].loadings.showLoadingSidebar;
                        return this.$store.getters["loadings/getLoadingState"]
                            .loadings.showLoadingSidebar;
                    },
                    showLoadingTemplate() {
                        this.loadings.showLoadingTemplate =
                            this.$store.getters[
                                "loadings/getLoadingState"
                            ].loadings.showLoadingTemplate;
                        return this.$store.getters["loadings/getLoadingState"]
                            .loadings.showLoadingTemplate;
                    },
                    showLoadingHeader() {
                        this.loadings.showLoadingHeader =
                            this.$store.getters[
                                "loadings/getLoadingState"
                            ].loadings.showLoadingHeader;
                        return this.$store.getters["loadings/getLoadingState"]
                            .loadings.showLoadingHeader;
                    },
                    showLoadingMain() {
                        this.loadings.showLoadingMain =
                            this.$store.getters[
                                "loadings/getLoadingState"
                            ].loadings.showLoadingMain;
                        return this.$store.getters["loadings/getLoadingState"]
                            .loadings.showLoadingMain;
                    },
                    showLoadingFooter() {
                        this.loadings.showLoadingFooter =
                            this.$store.getters[
                                "loadings/getLoadingState"
                            ].loadings.showLoadingFooter;
                        return this.$store.getters["loadings/getLoadingState"]
                            .loadings.showLoadingFooter;
                    },
                    tagManagementId() {
                        const raw = localStorage.getItem("@datadrive:domain");
                        let domainInfo = null;
                        if (raw) {
                            try { domainInfo = JSON.parse(raw); } catch (_) { domainInfo = null; }
                        }
                        return domainInfo ? domainInfo.tagManagerContainerID : null;
                    },
                    googleAnalyticsId() {
                        const raw = localStorage.getItem("@datadrive:domain");
                        let domainInfo = null;
                        if (raw) {
                            try { domainInfo = JSON.parse(raw); } catch (_) { domainInfo = null; }
                        }
                        return domainInfo ? domainInfo.googleAnalyticsContainerID : null;
                    },
                    hotjarSiteId() {
                        const raw = localStorage.getItem("@datadrive:domain");
                        let domainInfo = null;
                        if (raw) {
                            try { domainInfo = JSON.parse(raw); } catch (_) { domainInfo = null; }
                        }
                        return domainInfo ? domainInfo.hotjarSiteId : null;
                    },
                },
                methods: {
                    startWithLocalStorageVehicle() {
                        if (!_.isEmpty(localStorage.getItem("lastVehicle"))) {
                            let lastVehicle = JSON.parse(
                                localStorage.getItem("lastVehicle")
                            );
                            this.$store.commit(
                                "vehicleIdentification/setVehicleIdentification",
                                lastVehicle
                            );
                        }
                    },

                    getSubDomainAgain() {
                        if (
                            !_.isEmpty(
                                localStorage.getItem("@datadrive:domain")
                            )
                        ) {
                            let domainInfo = JSON.parse(
                                localStorage.getItem("@datadrive:domain")
                            );
                            this.$store.commit(
                                "domain/setStateDomainData",
                                domainInfo
                            );
                        } else {
                            AuthServicesDomainValidation()
                                .then((response) => {
                                    let res = response.data.result;
                                    this.$store.commit(
                                        "domain/setStateDomainData",
                                        res
                                    );
                                })
                                .catch((error) => {
                                    console.error(
                                        "error get domain validation",
                                        error
                                    );
                                });
                        }
                    },
                },
                created() {
                    /**
                     * @description if localstorage has info, set it on the store as well
                     */
                    if (!_.isEmpty(localStorage.getItem("budgetB2b"))) {
                        let budgetB2b = JSON.parse(
                            localStorage.getItem("budgetB2b")
                        );

                        if (
                            budgetB2b.shoppingCart.operations.maintenance
                                .length ||
                            budgetB2b.shoppingCart.operations.repair.length
                        ) {
                            this.$store.commit("budget/setB2b", budgetB2b);
                        }
                    }

                    const domain = JSON.parse(
                        localStorage.getItem("@datadrive:domain")
                    );
                    const initialState = JSON.parse(
                        localStorage.getItem("@datadrive:initialState")
                    );
                    let lang = "pt";
                    if (initialState) {
                        lang = initialState.languageCode;
                    } else if (domain) {
                        lang = domain.languageCode;
                    }

                    this.$i18n.locale = lang;
                    this.$vuetify.lang.current = lang;
                    dayjs.locale(lang);

                    /**
                     * Valida inicalmente se o localStorage não exite registro
                     * de matricula pesquisada.
                     * O localStorage tem prioridade na recuperação do último
                     * veículo pesquisado
                     *
                     * Existe a validação (IF) inversa dentro do component VehicleSearchComponent.vue
                     * para não iniciar pesquisando alguma placa de sessão do passo de identificação.
                     */
                    this.getSubDomainAgain();
                    this.startWithLocalStorageVehicle();

                    EventBusLoading.templateShowChanged((show) => {
                        this.loadings.showLoadingTemplate.show = show;
                    });
                    EventBusLoading.headerShowChanged((show) => {
                        this.loadings.showLoadingHeader.show = show;
                    });
                    EventBusLoading.sidebarShowChanged((show) => {
                        this.showLoadingSidebar.show = show;
                    });
                    EventBusLoading.mainShowChanged((show) => {
                        this.loadings.showLoadingMain.show = show;
                    });
                    EventBusLoading.footerShowChanged((show) => {
                        this.loadings.showLoadingFooter.show = show;
                    });

                    if (this.tagManagementId) {
                        $("#tagManagement1").html(`
                                (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                                new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                                j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                                'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                                })(window,document,'script','dataLayer','${this.tagManagementId}');
                              `);

                        $("#tagManagement2")
                            .html(`<iframe src="https://www.googletagmanager.com/ns.html?id=${this.tagManagementId}"
                              height="0" width="0" style="display:none;visibility:hidden"></iframe>`);
                    }

                    if (this.hotjarSiteId) {
                        $("#hotjarSite").html(`
                                (function(h,o,t,j,a,r){
                                  h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
                                  h._hjSettings={hjid:${this.hotjarSiteId},hjsv:6};
                                  a=o.getElementsByTagName('head')[0];
                                  r=o.createElement('script');r.async=1;
                                  r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
                                  a.appendChild(r);
                                })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
                              `);
                    }

                    if (this.googleAnalyticsId) {
                    }
                },
            }).$mount("#app");
        });
}

registerServiceWorker();
